<template>
<div id="spotlight" class="container">
    <div class="row">
        <div class="col-xs-12 artist no-padding">
            <p class="name">March and June</p>
            <p class="country">UK</p>
            <div class="image" style="background-image: url('https://api.soundfeedapp.com/api/image/12165e0e7e0f1408b3a020f289a55668.jpeg')"></div>
            <div class="type">Artist</div>
        </div>

        <div class="col-xs-12 content no-padding">
            <h3>In the spotlight:</h3>
            <p>March and June is a young musical project born in the fertile grounds of Romania’s electronic music landscape. With his real identity concealed behind a mask, he chose to speak only through his own productions, as unique as his vision when it comes to musical expression.</p>
            <span class="songs">4 <small>SONGS</small></span>
        </div>

        <div class="col-xs-12 footer no-padding">
            <router-link tag="div" class="button button-white" :to="'/song/5901'">Play song</router-link>
            <router-link tag="div" class="button button-white" :to="'/profile/363'">Follow artist</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    components: {
    },

    data() {
        return {

        }
    }, 

    mounted() {

    },

    methods: {
       
    },    
}
</script>